<template>
  <main class="modal-main" :class="{ 'user-select-open': isShowCopy }">
    <template v-if="!(isNoProduct || isRemind)">
      <div class="prod-popup no-padding">
        <div class="step-padding">
          <div class="t_999 t_center fs-26">第 1 步 (共 3 步)</div>
          <div class="t_title">{{ stepOneTitleFilter({ PlatformType: soHoInfo.PlatformType, SearchType: soHoInfo.SearchType }) }}</div>
          <div class="t_hlep no-border">如有疑问，请点击 <span class="t_blue" @click="showCourse(1)">如何搜索</span></div>
        </div>
        <div class="step-padding mar-top">
          <div class="t_key flex space-between">
            <div class="shrink t_999">购物平台</div>
            <LaunchAppBtn :soHoInfo="soHoInfo"></LaunchAppBtn>
          </div>
          <div v-if="isShowSearchKey(soHoInfo.SearchType)" class="t_key flex space-between key-guide">
            <div class="shrink t_999">关键词</div>
            <div class="key-words-box">
              <div class="key_tags threeRow">
                {{ soHoInfo.SearchKey ? soHoInfo.SearchKey : '--' }}
                <input type="text" id="shopKeyWords" :value="soHoInfo.SearchKey" readonly="true" />
              </div>
              <div class="key_copy" @click="copyKeyWord" v-if="isShowCopy">复制</div>
            </div>
          </div>
          <div class="t_key flex space-between key-guide-filter" v-if="haveScreen">
            <div class="shrink t_999">筛选条件</div>
            <div class="flex flex_wrap key-maxwidth">
              <div class="filter_tag" v-if="soHoInfo.SortType !== 0">按照{{ soHoInfo.SortType | sortType }}排序</div>
              <div class="filter_tag" v-if="soHoInfo.IsFreeShipping">顺丰包邮</div>
              <div class="filter_tag" v-if="soHoInfo.IsTmall">天猫</div>
              <div class="filter_tag" v-if="soHoInfo.IsGiveFI">退货包运费</div>
              <div class="filter_tag" v-if="soHoInfo.IsLimitPrice">价格：{{ soHoInfo.LimitLowPrice }}~{{ soHoInfo.LimitHighPrice }}元</div>
              <div class="filter_tag" v-if="soHoInfo.SendAddress">发货地：{{ soHoInfo.SendAddress }}</div>
              <template v-if="soHoInfo.ConfigCondition">
                <div class="filter_tag" v-for="(item, index) in configCondition" :key="index">{{ item }}</div>
              </template>
            </div>
          </div>
          <div class="t_key flex space-between" v-if="goodsRemark">
            <div class="shrink t_999">购物须知</div>
            <div class="flex flex_wrap key-maxwidth">
              <div class="filter_tag danger" v-for="(item, index) in remarkArr" :key="index">{{ item }}</div>
            </div>
          </div>
          <qrcode-part :goodsPic="WAPPicUrl" :SearchKey="soHoInfo.SearchKey" :PlatformType="soHoInfo.PlatformType" :isQrcodeMode="isQrcodeMode(soHoInfo.SearchType)"></qrcode-part>
        </div>
        <div class="emptyBox" style="width: 100%;height: 80px"></div>
      </div>
      <div class="tc_button">
        <div class="tc_btn shCancelBtn" @click="cancelOrder()">{{ isFreeCard ? '取消兑换' : '取消购买' }}</div>
        <!-- <template v-if="isFreeCard">
            <div class='tc_btn shCancelBtn' @click="cancelConvert(true)">取消兑换</div>
          </template>
          <template v-else>
            <div class="tc_btn shCancelBtn" @click="cancelOrder()">取消购买</div>
          </template> -->
        <div class="tc_btn shPrimaryBtn" @click="findProduct">找到了</div>
      </div>
    </template>
    <!-- 无库存显示 -->
    <out-of-stock-popup v-if="isNoProduct" @formSubmitRemind="formSubmitRemind"> </out-of-stock-popup>
    <!-- 已加入收藏显示 -->
    <add-collectioned v-if="isRemind"></add-collectioned>
    <!-- actionsheet -->
    <div :class="{ 'disabled-action': isCounting }">
      <mt-actionsheet :actions="actionsList" v-model="sheetVisible"> </mt-actionsheet>
    </div>
    <cancel-order-popup
      :isShow="isShowCancelOrderPopup"
      :isShowChangeKeyWordBtn="isShowChangeKeyWordBtn"
      @changeKeyWord="customChangeKeyWordEvent"
      @confirm="customCancelSaleTaskAccept"
      @close="closeCancelOrderPopup"
    ></cancel-order-popup>
    <!-- 如何搜索弹窗 -->
    <how-to-search-popup :isShow="isShowHowToSearchPopup" :currentPageInfo="currentPageInfo" @close="isShowHowToSearchPopup = false"></how-to-search-popup>
  </main>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import OutOfStockPopup from '@/views/purchaseProcess/children/OutOfStockPopup'
import AddCollectioned from '@/views/purchaseProcess/children/AddCollectioned'
import { ProductVerifyStageGet } from '@/api/question'
import stepOneMixin from '../../mixins/stepOneMixin'
import cancelOrder from '@/mixins/cancelOrder'

export default {
  mixins: [stepOneMixin, cancelOrder],
  data() {
    return {
      btnLoading: false,
      // 上一个页面路由
      beforeRouteName: '',
      platform: 1
    }
  },
  components: {
    OutOfStockPopup,
    AddCollectioned
  },
  mounted() {
    if (String(this.$route.query.isFreeCard) === 'true') {
      this.isFreeCard = true
    }
    this.WAPPicUrl = decodeURI(this.$route.query.wAPPicUrl)
    this.productID = this.$route.query.productId
    if (!this.getSoHoInfo) {
      this.fetchOpenShouhuoData()
    } else {
      this.soHoInfo = this.getSoHoInfo
      if (this.soHoInfo.ConfigCondition) this.configCondition = this.soHoInfo.ConfigCondition.split(',')
      this.handleKeyAndTime()
    }
  },
  methods: {
    // 步骤一 根据关键词 找到了商品
    findProduct() {
      if (this.btnLoading) return
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.btnLoading = true
      ProductVerifyStageGet({ taskId: this.soHoInfo.TaskId })
        .then((res) => {
          this.btnLoading = false
          Indicator.close()
          if (res.Data.VerifyPassMode) {
            // 商品链接验证
            this.$router.push({
              name: 'pddStepTwo',
              query: {
                productId: this.productID,
                keywordID: this.soHoInfo.KeywordID,
                isFreeCard: this.isFreeCard
              }
            })
          } else {
            // 问答
            this.switchVerityMode(res.Data.VerifyStage)
          }
        })
        .catch((err) => {
          this.btnLoading = false
          Indicator.close()
          Toast(err.ErrMsg)
        })
    },
    // 问答模式跳转
    switchVerityMode(VerifyStage) {
      switch (VerifyStage) {
        case 1:
          this.$router.push({
            name: 'pddQuestionOne',
            query: {
              taskID: this.soHoInfo.TaskId
            }
          })
          break
        case 2:
          // 天猫商品直接跳过回答问题第一步
          this.$router.push({
            name: 'pddQuestionTwo',
            query: {
              taskID: this.soHoInfo.TaskId
            }
          })
          break
        case 3:
          this.$router.push({
            name: 'pddQuestionThree',
            query: {
              taskID: this.soHoInfo.TaskId
            }
          })
          break
        case 4:
          this.$router.push({
            name: 'pddStepTwo',
            query: {
              productId: this.productID,
              keywordID: this.soHoInfo.KeywordID,
              isFreeCard: this.isFreeCard
            }
          })
          break
        case 5:
          this.$router.push({
            name: 'pddStepThree',
            query: {
              readyTaskId: this.soHoInfo.TaskId
            }
          })
          break
      }
    },
    // 返回上一页
    returnBeforeRoute() {
      let routeNameArray = ['souhuo', 'newProduct', 'onePackage', 'presellGood', 'searchResult', 'order', 'hadRefund', 'invitationEvaluation']
      if (routeNameArray.indexOf(this.beforeRouteName) !== -1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'souhuo'
        })
      }
    },
    // 商品已加入免单
    changeToFreeCard(infoMsg, isFreeCard) {
      MessageBox({
        title: '提示',
        message: infoMsg,
        showCancelButton: true,
        confirmButtonText: '留在此页',
        cancelButtonText: '返回',
        confirmButtonClass: 't_f23030'
      })
        .then((action) => {
          if (action === 'confirm') {
            this.$router.replace({
              name: 'pddStepOne',
              query: {
                productID: this.productID,
                isFreeCard: isFreeCard
              }
            })
            this.fetchOpenShouhuoData()
          } else {
            this.returnBeforeRoute()
          }
        })
        .catch((res) => {})
    }
  },
  beforeRouteEnter(to, from, next) {
    let fromRoutes = ['goodsDetail', 'pddStepTwo', 'courseStep', 'order', 'pddQuestionOne', 'pddQuestionTwo', 'pddQuestionThree']
    if (fromRoutes.indexOf(from.name) !== -1 || from.name === null) {
      next((vm) => {
        vm.beforeRouteName = from.name
      })
    } else {
      next({ name: 'souhuo' })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.SET_SOHO_INFO(null)
    MessageBox.close()
    next()
  }
}
</script>

<style scoped>
@import '../../step.scss';
.disabled-action >>> .mint-actionsheet-listitem:nth-of-type(1) {
  background: #eee;
  color: #bbb;
}
.tc_img img {
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  margin: auto auto;
}
.modal-main {
  user-select: none;
}
.user-select-open {
  user-select: text;
}
.key-guide-filter {
  align-items: flex-start;
}
.key-guide-filter .shrink {
  margin-top: 5px;
}
.t_key {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
/* 新手引导 */
.walk-through .guide-one-area {
  left: 50%;
  width: 96%;
  transform: translateX(-50%);
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.tool-tip .keywords-img {
  top: -43px;
  width: 340px;
  height: 220px;
  left: 2vh;
}
.tool-tip .next-btn {
  top: 35px;
  right: 10%;
  width: 123px;
}
/* img */
.tool-tip .goods-img {
  width: 300px;
  height: 200px;
  left: 1vh;
}
.tool-tip .know-btn {
  right: 10%;
}
@media screen and (max-width: 320px) {
  .tool-tip .keywords-img {
    left: -6vh;
  }
  .tool-tip .goods-img {
    left: -30px;
  }
  .tool-tip .know-btn {
    top: 380px !important;
    right: 0;
  }
}
</style>
